export default "__VITE_ASSET__CKtdJCqD__"